import React, { useState } from "react";
import { Form, Input, Button, Modal, message, notification } from "antd";
import { LockOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import updatedIcon from "../../../Assets/Icons/celebrate.svg";
import "./style.css";
import { changePasswordAPI } from "../../../API/userProfile";

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);
  const [logoutModalVisible, setLogoutModalVisible] = useState(false);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleDone = async () => {
    setLogoutModalVisible(false);
    navigate("/profile");
  };

  const initialValues = {
    current_password: "",
    new_password: "",
    confirm_password: "",
  };

  const handleSaveClick = async (values) => {
    try {
      setLoading(true);
      const response = await changePasswordAPI(values);
      if (Math.floor(response?.status / 100) === 2) {
        message.success("Password updated successfully!");
        setLogoutModalVisible(true);
        form.resetFields();
      } else {
        message.error(response?.data?.errors);
      }
    } catch (error) {
      message.error("Failed to fetch dashboard data Email Volume.");
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    form.resetFields();
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="page">
      <div className="back-btn">
        <Button icon={<ArrowLeftOutlined />} onClick={handleBack}>
          Back
        </Button>
      </div>
      <div className="edit-profile">
        <div className="edit-card">
          <div className="header">Change Password</div>
          <div className="border"></div>

          <div className="form change-form">
            <Form
              form={form}
              name="changePassword"
              layout="vertical"
              autoComplete="off"
              initialValues={initialValues}
              onFinish={handleSaveClick}
            >
              <Form.Item
                label="Current Password"
                name="current_password"
                rules={[
                  { required: true, message: "Enter your current password!" },
                ]}
              >
                <Input.Password
                  placeholder="Current Password"
                  prefix={<LockOutlined />}
                />
              </Form.Item>

              <div
                className="item"
                style={{ display: "flex", gap: "16px", alignItems: "center" }}
              >
                <Form.Item
                  label="New Password"
                  name="new_password"
                  style={{ flex: 1 }}
                  rules={[{ required: true, message: "Enter new password!" }]}
                >
                  <Input.Password
                    placeholder="New Password"
                    prefix={<LockOutlined />}
                  />
                </Form.Item>

                <Form.Item
                  label="Confirm Password"
                  name="confirm_password"
                  style={{ flex: 1 }}
                  dependencies={["password"]}
                  rules={[
                    { required: true, message: "Confirm your password!" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("new_password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    placeholder="Confirm Password"
                    prefix={<LockOutlined />}
                  />
                </Form.Item>
              </div>

              <Form.Item>
                <div className="form-footer">
                  <Button
                    type="primary"
                    className="cancel-btn"
                    onClick={handleReset}
                  >
                    Cancel
                  </Button>

                  <Button
                    className="save-btn"
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Save Changes
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>

        <Modal
          className="password-modal"
          open={logoutModalVisible}
          title={
            <div className="modal-header">
              <div className="modal-icon">
                <div
                  style={{
                    width: 106,
                    height: 106,
                    borderRadius: "60%",
                    backgroundColor: "#4928FD1A",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={updatedIcon}
                    alt="Password updated"
                    style={{ width: 62, height: 62 }}
                  />
                </div>
              </div>

              <div className="text">
                <div className="heading">Password Updated</div>
                <div className="description">
                  Your password has been changed successfully. Please use your
                  new password next time you log in.
                </div>
              </div>
            </div>
          }
          okText="Done"
          centered
          onOk={handleDone}
          confirmLoading={loading}
          cancelButtonProps={{ style: { display: "none" } }}
          onCancel={() => setLogoutModalVisible(false)}
        />
      </div>
    </div>
  );
};

export default ChangePassword;
